import { Component, ViewChild } from '@angular/core';
import { faEllipsisV, faEarthAsia, faSearch } from '@fortawesome/free-solid-svg-icons';
import { SignupComponent } from '../signup/signup.component';

@Component({
    selector: 'app-overview-panel',
    templateUrl: './overview-panel.component.html',
    styleUrls: ['./overview-panel.component.scss'],
})
export class OverviewPanelComponent {
    @ViewChild(SignupComponent) signUpModal!: SignupComponent;

    faEllipsisV = faEllipsisV;
    faEarthAsia = faEarthAsia;
    faSearch = faSearch;

    openSignUpModal(): void {
        this.signUpModal.openSignUpModal();
    }
}
